<script>
export default {
  name: "IconStackOverflow",
}
</script>

<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none"><path d="M17.24 19.399v-4.804h1.6V21H4.381v-6.405h1.598v4.804zM7.582 17.8h8.055v-1.604H7.582zm.195-3.64 7.859 1.641.34-1.552-7.861-1.642zm1.018-3.794 7.281 3.398.678-1.463-7.281-3.399-.678 1.454zm2.037-3.589 6.166 5.142 1.018-1.216-6.162-5.14-1.016 1.213zm3.982-3.778-1.311.969 4.803 6.454 1.313-.971-4.807-6.452z"/></svg>
</template>
